<template>
  <div :class="$style.style">
    <div class="img-view">
      <p class="pic-box" @click="showPicPopup(imgSrc)">
        <img :src="imgSrc" alt="">
      </p>
    </div>

    <!-- 图片查看弹窗 -->
    <div class="pic-popup" v-if="showPopup">
      <a href="javascript:;" class="close-btn" @click="showPicPopup('none')">×</a>
      <div class="img-view">
        <img :src="imgSrc" alt>
      </div>
    </div>
  </div>
</template>
<script>
  /*
  *
  */
import axios from 'axios';
import { Message } from 'element-ui';
export default {
  model: {
  },
  props: {
    imgSrc: { type: String, default: '' }
  },
  data () {
    return {
      showPopup:false
    }
  },
  mounted () {
    var self = this;
  },
  watch: {
  },
  methods: {

    //显示大图
    showPicPopup() {
      this.showPopup = !this.showPopup;
      // this.imgView = imgSrc == "none" ? null : imgSrc;
    },
  }
}
</script>
<style lang="less" module>
:local(.style) {
  .pic-box {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    border: 1px solid #d8dfe5;
    position: relative;
    z-index: 1;
    overflow: hidden;
    // margin-right: 10px;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:after {
      display: block;
      content: "";
      position: absolute;
      z-index: 2;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 24px;
      background: rgba(53, 64, 82, 0.5);
    }
    &:before {
      display: block;
      content: "查看";
      position: absolute;
      left: 50%;
      bottom: 0;
      margin-left: -20px;
      z-index: 3;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: url("//img1.jianyewy.com/58e3a660a552998cef8c66edd1357106.png")
        no-repeat;
      background-size: 13px;
      background-position: left center;
      padding-left: 16px;
    }
    img {
      width: 100px;
      max-height: 100px;
    }
  }
  /* 图片弹窗 */
  .pic-popup {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(53, 64, 82, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    .close-btn {
      position: absolute;
      right: 30px;
      top: 25px;
      width: 19pxd;
      font-size: 30px;
      line-height: 30px;
      color: #d8dfe5;
    }
    .img-view,
    img {
      width: 400px;
      max-height: 400px;
    }
  }
}
</style>